export default __webpack_public_path__ + "static/media/instagram-3-16.13f18969.ico";